import { useEffect, useRef } from "react";
import styles from "./GlowingTree.module.css";

export function GlowingTree({
  treeSrc = "/tree.png",
  maskSrc = "/mask.png",
  width = "300px",
  height = "auto"
}) {
  const maskRef = useRef(null);

  useEffect(() => {
    let running = true;

    function randomBlink() {
      if (!running || !maskRef.current) return;

      // случайная яркость
      const brightness = 2 + Math.random() * 2; // 2–4
      const saturate = 2 + Math.random() * 1.5; // 2–3.5
      const opacity = 0.7 + Math.random() * 0.3; // 0.7–1.0

      maskRef.current.style.filter = `brightness(${brightness}) saturate(${saturate})`;
      maskRef.current.style.opacity = opacity.toString();

      // следующее мигание через 200–700 мс
      const delay = 200 + Math.random() * 500;
      setTimeout(randomBlink, delay);
    }

    randomBlink();

    return () => {
      running = false;
    };
  }, []);

  return (
    <div
      className={styles.wrapper}
      style={{ width, height }}
    >
      <img src={treeSrc} className={styles.tree} alt="tree" />

      <div
        ref={maskRef}
        className={styles.mask}
        style={{ backgroundImage: `url(${maskSrc})` }}
      ></div>
    </div>
  );
}
